// 확장자를 적는 이유: 단위 시험(`tests/unit/csrfHeaders.test.js`)이 이 파일을 node 에서 그대로 읽는다 — node ESM 은 상대 경로의
// 확장자를 추론하지 않는다.
import { csrfHeaders as csrfHeadersOf } from '../plugins/http/policy.js'

const setStorage = (key, payload) => {
  const storageKey = `vuex_auth_${key}`

  sessionStorage.setItem(storageKey, JSON.stringify(payload))
}
const getStorage = (key) => {
  const storageKey = `vuex_auth_${key}`

  return JSON.parse(sessionStorage.getItem(storageKey))
}

const initialAuth = {
  agreeYn: null,
  alarmYn: null,
  isOrderNoti: null,
  sa_account: null,
  sa_actions: null,
  sa_show_nm: null,
  storeId: null,
  storeIds: null, // 샵인샵 — 대표 매장 로그인 시 그룹 전체 storeId (주문알림 다중 구독)
  csrfToken: null,
}

const getState = () => {
  const auth = getStorage('auth') ?? initialAuth

  return {
    auth,
  }
}

const authModule = {
  namespaced: true,
  state: getState,
  getters: {
    isLogin(state) {
      return state.auth.sa_account !== null
    },
    showNm(state) {
      return state.auth.sa_show_nm
    },
    auth(state) {
      return state.auth
    },
    authId(state) {
      return state.auth.sa_account.auths[0]?.authId
    },
    /**
     * 세션의 **역할 배열 전부** — 겸직 계정에서 서버(`CallerScope`)와 같은 답을 내야 하는 판정이 읽는다
     * (`utils/adminRole.hasCallpopRole`). `authId` 는 첫 역할 하나라 그 질문에 쓰면 답이 갈린다.
     *
     * 세션 모양을 아는 자리를 늘리지 않으려고 여기에 둔다 — 화면이 `sa_account.auths` 를 직접 파고들면
     * 로그아웃 직후의 `sa_account: null` 을 화면마다 다시 막아야 한다.
     */
    auths(state) {
      return (state.auth.sa_account && state.auth.sa_account.auths) || []
    },
    authNm(state) {
      return state.auth.sa_account.auths[0]?.authNm
    },
    accountNm(state) {
      return state.auth.sa_account.accountNm
    },
    /**
     * 계정 ID — **계정마다 따로 두어야 하는 로컬 상태**의 키다(매장 선택 창의 「최근 고른 매장」).
     *
     * 한 브라우저에서 계정을 갈아 쓰면 앞 계정이 남긴 값이 다음 계정의 화면에 뜬다 — 그 계정은 그
     * 매장을 볼 수 없을 수도 있다. [auths] 와 같은 이유로 여기 둔다: 화면이 `sa_account` 를 직접
     * 파고들면 로그아웃 직후의 `null` 을 화면마다 다시 막아야 한다.
     */
    accountId(state) {
      return (state.auth.sa_account && state.auth.sa_account.accountId) || ''
    },
    csrfToken(state) {
      return state.auth.csrfToken
    },
    /**
     * 세션(쿠키)으로 인증되는 쓰기에 실을 CSRF 헤더 — **지금 토큰에서 셈한다**(이름·모양은 `plugins/http/policy.csrfHeaders` 한 곳).
     * axios 밖의 직접 업로드(`el-upload` 의 `:headers`)가 계산 속성(`mapGetters`)으로 쓴다 — 화면을 연 때의 값을 담아 두지 않는다.
     */
    csrfHeaders(state) {
      return csrfHeadersOf(state.auth.csrfToken)
    },
  },
  mutations: {
    setAuth(state, payload) {
      state.auth.agreeYn = payload.agreeYn
      state.auth.alarmYn = payload.alarmYn
      state.auth.isOrderNoti = payload.isOrderNoti
      state.auth.sa_account = payload.sa_account
      state.auth.sa_actions = payload.sa_actions
      state.auth.sa_show_nm = payload.sa_show_nm
      state.auth.storeId = payload.storeId
      state.auth.storeIds = payload.storeIds
      state.auth.csrfToken = payload.csrfToken
    },
  },
  actions: {
    setAuth({ commit }, payload) {
      setStorage('auth', payload)

      commit('setAuth', payload)
    },
    logout({ commit }) {
      commit('setAuth', {
        ...initialAuth,
      })

      sessionStorage.clear()
    },
  },
}

export default authModule
